import React, { Fragment, useContext, useEffect, useState } from "react";
import { Box, Container, Typography, Grid, Button } from "@material-ui/core";
import { httpPost } from "../../lib/apiClients";
import { AxiosResponse } from "axios";
import { Link, useNavigate } from "react-router-dom";
import { emailValid } from "../../lib/validation";
import ButtonLoader from "../../components/ButtonLoader";
import { AuthContext } from "../../auth/AuthContext";
import SectionHeader from "../../components/SectionHeader";
import { Environment } from "../../utils/environments";
import LoaderComponent from "../../components/LoaderComponent";

export default function EmailChangeRequest() {
  const [emailError, setEmailError] = useState<boolean | string>(false);
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);
  useEffect(() => {
    document.title = "メールアドレス変更リクエスト | じぶん専用IT相談室";
    if (currentUser === undefined) {
      return;
    }
    if (!currentUser) {
      navigate("/login", {
        state: {
          from: window.location.pathname,
          search: window.location.search,
        },
      });
    }
  }, [currentUser]);
  async function handleSubmit(e) {
    e.preventDefault();
    if (loading) {
      return;
    }
    setLoading(true);
    var emailInput = e.target.elements[0].value.trim();
    setEmailError(false);
    if (!emailValid(emailInput)) {
      if (email.length > 319) {
        setEmailError("メールアドレスは、319文字以内で入力してください");
      } else {
        setEmailError("メールアドレス形式で入力してください");
      }
      setLoading(false);
      return;
    }
    try {
      await httpPost({
        pathName: "email-change-request",
        bodyParams: {
          email: emailInput,
        },
      }).then((response: AxiosResponse<any>) => {
        if (response.status == 200) {
          navigate("/settings/email-change-request-complete");
        }
      });
    } catch (error) {
      if (error.response.status >= 400 && error.response.status <= 499) {
        setEmailError(
          "メールアドレスの形式にあやまりがあるか既に登録済のメールアドレスです。"
        );
      } else {
        error?.response?.status &&
          navigate(`/error?code=${error.response.status}`);
      }
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
    } finally {
      setLoading(false);
    }
  }
  return (
    <Fragment>
      {currentUser ? (
        <Box component={"section"} className="section bg-dots">
          <Container className="container" style={{ marginBottom: "50px" }}>
            <SectionHeader
              currentPage={"メールアドレス変更の<br/>URLを送信します"}
              preHeading={"Email Change"}
            />
            <Typography className="text-center mobile-text-left">
              入力いただいたアドレス宛にメールアドレス変更URLを送信します。
              メール文中の「メールアドレス変更URL」をクリックしてください。
            </Typography>
          </Container>
          <Container className="container">
            <Box className="element-box">
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item md={3} sm={3} xs={12}>
                    <label>
                      メールアドレス<span className="required">必須</span>
                    </label>
                  </Grid>
                  <Grid item md={6} sm={9} xs={12}>
                    <input
                      type="text"
                      placeholder="メールアドレス"
                      className="input-field"
                      maxLength={319}
                      onChange={(e) => {
                        setEmail(e.target.value.trim());
                      }}
                      required
                    />
                    {emailError && (
                      <Typography className="error-message">
                        {emailError}
                      </Typography>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ margin: "30px 0", textAlign: "center" }}
                  >
                    {loading && <div className="button-overlay"></div>}
                    <button
                      className="classification-btn"
                      type="submit"
                      disabled={email.length < 1 || loading}
                    >
                      {loading ? <ButtonLoader /> : "送信する"}
                    </button>
                  </Grid>
                </Grid>
              </form>
              <Typography component={"p"} className="text-center">
                <Link
                  to={"/settings"}
                  style={{
                    borderBottom: "1px solid",
                    color: "var(--secondary-color)",
                  }}
                >
                  お客様情報画面
                </Link>
                に戻る
              </Typography>
            </Box>
          </Container>
        </Box>
      ) : (
        <LoaderComponent />
      )}
    </Fragment>
  );
}
